<div
  id="jotform-container"
  class="w-full"
  [ssDirectus]="{
    collection: 'jotformBlock',
    item: jotformBlockData.id,
    fields: ['formID'],
  }"
></div>
